import {FieldModel} from '../../model/farms/FieldModel';
import {BaseCollection} from '../BaseCollection.js';
import {BaseFilterModel} from '../../model/filter/BaseFilterModel';

/**
 * @class FieldCollection
 * @extends BaseCollection
 */
export class FieldCollection extends BaseCollection {

    initialize (models, options) {
        
        super.initialize(models, options);

        if(options && options.farmUuid){
            this._farmUuid = options.farmUuid;
        }

        this.microservice = 'farms';
        this.resource = 'v2/fields';
    }

    get farmUuid () {

        return this._farmUuid;
    }

    set farmUuid (uuid) {

        this._farmUuid = uuid;

        let filter = new BaseFilterModel({
            farmUuid: uuid
        });

        this.options.filterParams = filter;
    }

    get model () {

        return FieldModel;
    }

    /**
     * @description To calculate the total area of all the fields
     *
     * @returns {Number} Total area
     */
    totalArea (){

        return this.reduce((memo, value) => (memo + value.get("area")), 0);
    }

    static cmpName (a, b) {

        const name1 = a.get('name').toLowerCase();
        const name2 = b.get('name').toLowerCase();
        const first = -1, second = 1, same = 0;

        try {
            if( name1 > name2) {
                return second;
            } else if (name2 > name1) {
                return first;
            }else {
                return same;
            }
        } catch (error) {
            return same;
        }
    }
}



// WEBPACK FOOTER //
// ./shared/collection/farms/FieldCollection.js